import "./style.css";

import React, { memo } from "react";

import { TLanguage } from "../../../../../../../../../interfaces/watch";
import { useCustomPlayerContext } from "../../../../../../../../../contexts/CustomPlayerContext";

interface SubMenuItemProps {
  data: number | TLanguage | string;
  name: string;
  checked: boolean;
  className?: string;
  onChange?: () => void;
}

const SubMenuItem: React.FC<SubMenuItemProps> = ({
  data,
  name,
  checked,
  className,
  onChange,
}) => {
  const { customPlayerPreferences } = useCustomPlayerContext();
  return (
    <label className={className}>
      <input
        type="radio"
        style={
        Boolean(checked && customPlayerPreferences.customPrimaryColor)
          ? { boxShadow: `0 0 0 8px ${customPlayerPreferences.customPrimaryColor}` }
          : undefined
      }
        onChange={onChange}
        value={data}
        checked={checked}
      />
      <span>{name}</span>
    </label>
  );
};

export default memo(SubMenuItem);
